import Typography from "@mui/material/Typography"

interface Props {
  variant?:
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "subtitle1"
  | "subtitle2"
  | "body1"
  | "body2"
  | "caption"
  | "button"
  | "overline"
  | "inherit"
  | undefined
  sx?: any
  label?: string
}

// Typography Component
const CustomTypography = (props: Props): React.ReactElement => {
  const { sx, variant, label } = props
  return (
    <Typography variant={variant} sx={sx}>
      {label}
    </Typography>
  )
}

export default CustomTypography
